<template>
  <div
    class="employee-inner employee-inner-permission"
    :class="{'employee-inner-full' : tabActive}"
  >
    <ListInfo :loadData="loadData" :setup-panel="contractList" @open-detail="openDetail('contract', $event)" @open-modal="openModal($event)" />

    <ListInfo :loadData="loadData" :setup-panel="decreeList" @open-detail="openDetail('decree', $event)" @open-modal="openModal($event)" />

    <ListInfo :loadData="loadData" :setup-panel="documentList" @open-detail="openDetail('document', $event)" @open-modal="openModal($event)" />

    <!-- Training document -->
    <!-- <div class="leave-content">
      <div class="content-header">
        <p>Training Document</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Expiring</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiringDoc.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiringDoc.length != 0)" class="inner-list">
            <div v-for="data in expiringDoc" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiringDoc', true, formatList(expiringDocfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Expired</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiredDoc.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiredDoc.length != 0)" class="inner-list">
            <div v-for="data in expiredDoc" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiredDoc', true, formatList(expiredDocfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Leave addition -->
    <!-- <div class="leave-content">
      <div class="content-header">
        <p>Leave Addition</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Expiring</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiringLeave.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiringLeave.length != 0)" class="inner-list">
            <div v-for="data in expiringLeave" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiringLeave', true, formatList(expiringLeavefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Expired</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiredLeave.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiredLeave.length != 0)" class="inner-list">
            <div v-for="data in expiredLeave" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiredLeave', true, formatList(expiredLeavefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Contract -->
    <!-- <div class="leave-content">
      <div class="content-header">
        <p>Contract</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Expiring</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiringContract.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiringContract.length != 0)" class="inner-list">
            <div v-for="data in expiringContract" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiringContract', true, formatList(expiringContractfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Expired</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiredContract.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiredContract.length != 0)" class="inner-list">
            <div v-for="data in expiredContract" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiredContract', true, formatList(expiredContractfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Career Path -->
    <!-- <div class="leave-content">
      <div class="content-header">
        <p>Career Path</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Expiring</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiringCareer.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiringCareer.length != 0)" class="inner-list">
            <div v-for="data in expiringCareer" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiringCareer', true, formatList(expiringCareerfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Expired</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (expiredCareer.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (expiredCareer.length != 0)" class="inner-list">
            <div v-for="data in expiredCareer" :key="data" class="inner-list-detail">
              <p>{{ formatDate(data.transaction_no, 'date') }}</p>
              <p>{{ data.info }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('expiredCareer', true, formatList(expiredCareerfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import ListInfo from "./ListInfo.vue"

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: false },
      loadData: { type: Boolean, default: false },
      thisMonthnow: { type: String, default: "" },

      expiringContract: { type: Object, default: [] },
      expiredContract: { type: Object, default: [] },
      expiringContractfull: { type: Object, default: [] },
      expiredContractfull: { type: Object, default: [] },

      expiringDecree: { type: Object, default: [] },
      expiredDecree: { type: Object, default: [] },
      expiringDecreefull: { type: Object, default: [] },
      expiredDecreefull: { type: Object, default: [] },

      expiringDoc: { type: Object, default: [] },
      expiredDoc: { type: Object, default: [] },
      expiringDocfull: { type: Object, default: [] },
      expiredDocfull: { type: Object, default: [] },

      expiringLeave: { type: Object, default: [] },
      expiredLeave: { type: Object, default: [] },
      expiringLeavefull: { type: Object, default: [] },
      expiredLeavefull: { type: Object, default: [] },
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const contractList = ref({})
      const decreeList = ref({})
      const documentList = ref({})


      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      const shortDaysId = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"]
      const shortDaysEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      function formatDate(date, type) {
        const day = new Date(date).getDate()
        const month = new Date(date).getMonth()
        const year = new Date(date).getFullYear()
        const dayOfWeek = new Date(date).getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
            return `${days[dayOfWeek]}, ${day} ${months[month]} ${year}`
        }
        else if(type == 'date') {
            return `${day} ${months[month]} ${year}`
        }
        else if(type == 'day') {
            return `${day}`
        }
        else if(type == 'shortDay') {
            return `${daysShort[dayOfWeek]}`
        }
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.forEach(item => {
          const dateObj = new Date(item.transaction_no)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }


      const openModal = (data) => {
        emit("open-modal", data)
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.expiringContract ||
          props.expiredContract ||
          props.expiringContractfull ||
          props.expiredContractfull
        ) {
          contractList.value = {
            id: "contract_list_container",
            title: "Contract",
            month: null,
            child: [
              {
                id: "expiringContract",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringContract,
                dataFull: props.expiringContractfull
              },
              {
                id: "expiredContract",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredContract,
                dataFull: props.expiredContractfull
              },
            ]
          }
        }

        if(
          props.expiringDecree ||
          props.expiredDecree ||
          props.expiringDecreefull ||
          props.expiredDecreefull
        ) {
          decreeList.value = {
            id: "decree_list_container",
            title: "Decree",
            month: null,
            child: [
              {
                id: "expiringDecree",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringDecree,
                dataFull: props.expiringDecreefull
              },
              {
                id: "expiredDecree",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredDecree,
                dataFull: props.expiredDecreefull
              },
            ]
          }
        }

        if(
          props.expiringDoc ||
          props.expiredDoc ||
          props.expiringDocfull ||
          props.expiredDocfull
        ) {
          documentList.value = {
            id: "document_list_container",
            title: "Document",
            month: null,
            child: [
              {
                id: "expiringDoc",
                title: "Is Expiring",
                container_color: 'yellow',
                dataShow: props.expiringDoc,
                dataFull: props.expiringDocfull
              },
              {
                id: "expiredDoc",
                title: "Is Expired",
                container_color: 'red',
                dataShow: props.expiredDoc,
                dataFull: props.expiredDocfull
              },
            ]
          }
        }
      })

      return {
        formatDate,
        formatList,
        openModal,
        contractList,
        decreeList,
        documentList,
        openDetail
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
